type NotificationData = Record<string, unknown>;

export type NotificationResponse = {
  notification: {
    request: {
      identifier: string;
      content: {
        data?: NotificationData;
      };
    };
  };
};

type PermissionStatus = 'undetermined' | 'denied' | 'granted';

type PermissionResponse = {
  status: PermissionStatus;
};

type ExpoPushTokenResponse = {
  data: string;
};

type NotificationHandler = {
  handleNotification: () => Promise<{
    shouldShowAlert: boolean;
    shouldPlaySound: boolean;
    shouldSetBadge: boolean;
    shouldShowBanner?: boolean;
    shouldShowList?: boolean;
  }>;
};

type NotificationResponseSubscription = {
  remove: () => void;
};

export function setNotificationHandler(_handler: NotificationHandler): void {
  // Web does not support expo-notifications in this app.
}

export async function getPermissionsAsync(): Promise<PermissionResponse> {
  return { status: 'denied' };
}

export async function requestPermissionsAsync(): Promise<PermissionResponse> {
  return { status: 'denied' };
}

export async function getExpoPushTokenAsync(): Promise<ExpoPushTokenResponse> {
  throw new Error('Push notifications are not available on web.');
}

export async function getLastNotificationResponseAsync(): Promise<NotificationResponse | null> {
  return null;
}

export function addNotificationResponseReceivedListener(
  _listener: (response: NotificationResponse) => void,
): NotificationResponseSubscription {
  return {
    remove() {},
  };
}
